
<div class="h-full relative"
  [class.no-day-headers]="!showDayHeader()"
  [class.all-day-collapsed]="allDayCollapsed"
  [class.has-extra-all-day-events]="hasExtraAllDayEvents()">
  <mwl-calendar-week-view
    [viewDate]="viewDate()"
    [excludeDays]="excludeDays()"
    [eventTemplate]="eventTemplate"
    [allDayEventsLabelTemplate]="allDayLabelTemplate"
    [currentTimeMarkerTemplate]="markerTemplate"
    [events]="calendarEvents()"
    [refresh]="refresh"
    [locale]="LOCALE_ID"
    [weekStartsOn]="firstDayOfWeek()"
    [hourSegmentTemplate]="weekViewHourSegment"
    (eventTimesChanged)="handleMove($event)"
    (dayHeaderClicked)="handleDayHeaderClick($event.day.date, $event.sourceEvent)"
  />
</div>

<ng-template #markerTemplate let-top="topPx" let-visible="isVisible">
  @if (visible) {
    <div
      #currentTimeMarker
      class="marker"
      [style.top.px]="top"
      >
      <div class="bubble"></div>
    </div>
  }
</ng-template>

<ng-template #allDayLabelTemplate>
  @if (hasExtraAllDayEvents()) {
    <app-button2 appearance="secondary" size="s"
      (click)="toggleAllDay()"
      class="items-end justify-center w-[56px] pb-4 bg-background">
      <app-icon [name]="allDayCollapsed ? 'chevron-down' : 'chevron-up'"/>
    </app-button2>
  }
</ng-template>

<ng-template #eventTemplate let-weekEvent="weekEvent">
  <!-- The quick-create placeholder (no id yet) is see-through for the pointer, see the stylesheet. -->
  @if (weekEvent.event.allDay) {
    <div class="px-2 py-1 h-full" [attr.data-quick-create-placeholder]="weekEvent.event.meta.id ? null : ''">
      <stch-event-preview-small [event]="weekEvent.event.meta" class="h-full"
        (appClick)="eventClicked.emit(weekEvent.event.meta)" (appDblClick)="eventDblClicked.emit(weekEvent.event.meta)"
      />
    </div>

    @if (allDayCollapsed) {
      @let dayGroup = groupedAllDayEvents()[getDayDateTime(weekEvent.event.meta.startTime)];
      @if (dayGroup && dayGroup.events.length > 0) {
        @if (dayGroup.events.length !== dayGroup.collapsedEvents.length) {
          <app-button2 appearance="primary-text" size="s" class="show-more-all-day-events pl-3" (click)="toggleAllDay()">
            + {{ dayGroup.events.length - dayGroup.collapsedEvents.length }} More
          </app-button2>
        }
      }
    }
  } @else {
    <div class="px-2 py-0 h-full" [attr.data-quick-create-placeholder]="weekEvent.event.meta.id ? null : ''">
      <stch-event-preview-big [event]="weekEvent.event.meta"
        class="h-full pb-[1px]"
        (appClick)="eventClicked.emit(weekEvent.event.meta)"
        (appDblClick)="eventDblClicked.emit(weekEvent.event.meta)"
      />
    </div>
  }
</ng-template>

<ng-template
  #weekViewHourSegment
  let-segment="segment"
  let-isTimeLabel="isTimeLabel"
  let-daysInWeek="daysInWeek"
  let-segmentHeight="segmentHeight"
  >
  <div
    class="cal-hour-segment"
    [style.height.px]="segmentHeight"
    [class.cal-hour-start]="segment.isStart"
    [class.cal-after-hour-start]="!segment.isStart"
    [class.weekend]="segment.date | weekend"
    [ngClass]="segment.cssClass"
  >
    @if (isTimeLabel) {
      <div class="cal-time">
        {{ segment.date | dateFormat : 'timeShort' }}
      </div>
    }

    @if (!isTimeLabel) {
      <div
        #cell
        class="cell"
        (appClick)="clickHourSegment($event, segment.date, cell)"
        (appDblClick)="dblClickHourSegment(segment.date)"
        [appCalendarCellContextMenu]="segment.date"
        [appCalendarCellContextMenuCalendarType]="calendarType()"
        appDroppable
        appDroppableHoverClass="drag-over"
        (appDroppableDrop)="handleDrop($event, segment.date, cell)"
      ></div>
    }
  </div>
</ng-template>
